/**
 * News
 *
 */
const News = {
  postType: [],
  currentPage: 1,

  init: () => {
    // get load more btn
    const loadMoreButton = document.getElementById(
      "archive-news__btn-load-more"
    );

    if (!loadMoreButton) return;

    // setup load more btn event
    loadMoreButton.addEventListener("click", function (e) {
      e.preventDefault();
      News.currentPage++;
      News.ajaxRequest(false); // get posts
    });

    // get form element
    const formEl = document.getElementById("archive-news__form");

    if (!formEl) return;

    // setup form change event
    formEl.addEventListener("change", function () {
      News.applyFilter();
    });
  },

  // get every checked checkbox
  getCheckedBoxes: () => {
    return Array.from(
      document.querySelectorAll('input[name="post_type"]:checked')
    );
  },

  applyFilter: () => {
    // reset
    News.postType = [];
    News.currentPage = 1;

    // get checked boxes
    const checkedBoxes = News.getCheckedBoxes();

    // add checked boxes to post type array
    if (checkedBoxes) {
      checkedBoxes.forEach((checkbox) => {
        News.postType.push(checkbox.value);
      });
    }

    // update result
    if (News.postType.length === 0) {
      News.clearResult(); // none selected
    } else {
      News.ajaxRequest(true); // post types selected - get posts!
    }
  },

  // clear result
  clearResult: () => {
    const resultsBox = document.getElementById("results");

    if (resultsBox) {
      resultsBox.innerHTML = "";
      News.showBtn(false);
    }
  },

  // show/hide loadMoreButton
  showBtn: (show) => {
    const loadMoreButton = document.getElementById(
      "archive-news__btn-load-more"
    );

    if (loadMoreButton) {
      if (show) {
        loadMoreButton.classList.add("archive__btn-load-more--is-visible");
      } else {
        loadMoreButton.classList.remove("archive__btn-load-more--is-visible");
      }
    }
  },

  // loading toggle TODO!
  isLoading: (loading) => {
    console.log("isLoading: " + loading);
    const archiveBody = document.querySelector(".archive__body");

    if (archiveBody) {
      if (loading) {
        archiveBody.classList.add("archive__body--is-loading");
      } else {
        archiveBody.classList.remove("archive__body--is-loading");
      }
    }
  },

  // fetch posts
  ajaxRequest: function (overrideResult) {
    const $ = jQuery;
    const resultsBox = document.getElementById("results");
    if (!resultsBox) return;

    $.ajax({
      type: "post",
      dataType: "json",
      url: siteData.ajaxUrl,
      data: {
        action: "netzero_load_news",
        security: siteData.nonce,
        paged: News.currentPage,
        post_type: News.postType,
      },

      beforeSend: function () {
        News.isLoading(true);
        News.showBtn(false);
      },

      success: function (res) {
        console.log("Found: " + res.total);

        // check if last page
        if (News.currentPage >= res.max) {
          News.showBtn(false);
        } else {
          News.showBtn(true);
        }

        // render result
        if (overrideResult) {
          resultsBox.innerHTML = res.html;
        } else {
          // append posts
          resultsBox.insertAdjacentHTML("beforeend", res.html);
        }
      },

      error: function (xhr, status, error) {
        News.isLoading(false);
        News.showBtn(true);

        console.log(xhr);
        console.log(status);
        console.log(error);
      },

      complete: function () {
        News.isLoading(false);
      },
    });

    return false;
  },
};

export default News;
